import { createFileRoute } from "@tanstack/react-router";
import FansHome from "@/components/fans/FansHome";
import ArtistsOverview from "@/components/marketing/overview/ArtistsOverview";
import { hasActiveSession } from "@/lib/auth";
import { seoHead, SITE_DESCRIPTION, SITE_TITLE } from "@/lib/seo";

// No redirect, so lutely.com keeps its URL: signed out it shows For Artists,
// signed in the fans page. Checked before render so nothing flickers.
export const Route = createFileRoute("/")({
  beforeLoad: async () => ({ signedIn: await hasActiveSession() }),
  component: HomePage,
  // Search results keep today's homepage title and description.
  head: () =>
    seoHead({
      title: SITE_TITLE,
      description: SITE_DESCRIPTION,
      canonicalPath: "/",
    }),
});

function HomePage() {
  const { signedIn } = Route.useRouteContext();
  return signedIn ? <FansHome /> : <ArtistsOverview />;
}
